import { blokToComponent } from '../../helpers/blok-to-component';
import { BlokToComponentProps } from '../../helpers/blok-to-component/types';

type RocheAccordionTabsPropsItem = BlokToComponentProps<any>;

export const RocheAccordionTabsItem = ({ blok, getComponent }: RocheAccordionTabsPropsItem) => {
  return blok.slotted?.map((item) => blokToComponent({ getComponent, blok: item }, 'roche-accordion-tabs-item'));
};
